var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBot)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"fastgpt-bot-host"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }